//TODO: DELETE ME
export default [
  20,
  25,
  30,
  35,
  40
];



// WEBPACK FOOTER //
// ./shared/common/staticData/hoursPerWeekList.js